import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { Target, TrendingUp, Award, Heart, Sparkles, Activity } from 'lucide-react';
export default function Landing() {
  const features = [{
    icon: Target,
    title: 'Metas SMART',
    description: 'Defina objetivos específicos, mensuráveis e alcançáveis para cada área da vida.'
  }, {
    icon: TrendingUp,
    title: 'Roda da Vida',
    description: 'Avalie seu momento atual e identifique áreas que precisam de atenção.'
  }, {
    icon: Award,
    title: 'Desafio 90 Dias',
    description: 'Transforme sua vida com o poder da consistência e conquiste hábitos duradouros.'
  }, {
    icon: Heart,
    title: 'Desenvolvimento Integral',
    description: 'Trabalhe 6 pilares: Pessoal, Profissional, Espiritual, Saudável, Social e Sentimental.'
  }, {
    icon: Sparkles,
    title: 'Gamificação',
    description: 'Ganhe badges, acompanhe seu streak e celebre cada conquista.'
  }, {
    icon: Activity,
    title: 'Acompanhamento Diário',
    description: 'Frases motivacionais, progresso visual e hábitos que constroem sua melhor versão.'
  }];
  return <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative overflow-hidden gradient-hero py-20 md:py-32">
        <div className="container px-4">
          <div className="mx-auto max-w-3xl text-center text-white animate-fade-in">
            <div className="flex justify-center mb-8">
              <div className="bg-white/95 p-6 rounded-2xl shadow-2xl backdrop-blur-sm border border-white/20">
                <img 
                  src="/logo/logo-vertical-full.png" 
                  alt="Trilha Da Disciplina" 
                  className="h-32 md:h-40 animate-fade-in" 
                />
              </div>
            </div>
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl mb-6">
              Transforme Sua Vida em{' '}
              <span className="text-yellow-300">90 Dias</span>
            </h1>
            <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed">
              Seu coach de desenvolvimento pessoal. Crie metas, construa hábitos e
              evolua nos 6 pilares da vida com disciplina e motivação.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch">
              <Button 
                size="lg" 
                variant="secondary" 
                className="text-lg px-8 py-6 min-h-[56px] shadow-lg hover:shadow-xl transition-shadow touch-manipulation" 
                asChild
              >
                <Link to="/auth/signup">Começar agora</Link>
              </Button>
              <Button 
                size="lg" 
                variant="outline" 
                className="text-lg px-8 py-6 min-h-[56px] bg-white/10 text-white border-white/30 hover:bg-white/20 touch-manipulation" 
                asChild
              >
                <Link to="/auth/login">Já tenho conta</Link>
              </Button>
            </div>
          </div>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl pointer-events-none" />
      </section>

      {/* Features Section */}
      <section className="py-20 bg-muted/30">
        <div className="container px-4">
          <div className="mx-auto max-w-2xl text-center mb-16">
            <h2 className="text-3xl font-bold mb-4">Por que TDD?</h2>
            <p className="text-lg text-muted-foreground">
              Uma abordagem completa para transformar cada área da sua vida.
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto">
            {features.map((feature, index) => {
            const Icon = feature.icon;
            return <Card key={index} className="border-none shadow-md hover:shadow-lg transition-shadow animate-slide-up" style={{
              animationDelay: `${index * 0.1}s`
            }}>
                  <CardContent className="pt-6">
                    <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg gradient-hero">
                      <Icon className="h-6 w-6 text-white" />
                    </div>
                    <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
                    <p className="text-muted-foreground">{feature.description}</p>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20">
        <div className="container px-4">
          <Card className="max-w-4xl mx-auto gradient-card border-none shadow-xl">
            <CardContent className="p-8 md:p-12 text-center">
              <h2 className="text-3xl font-bold mb-4">Pronto para sua transformação?</h2>
              <p className="text-lg text-muted-foreground mb-8">Junte-se a centenas de pessoas que já estão construindo a vida que sempre sonharam.</p>
              <Button size="lg" className="text-lg px-8" asChild>
                <Link to="/auth/signup">Criar conta grátis</Link>
              </Button>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>;
}